import * as tslib_1 from "tslib";
import { Base } from '../base-component';
import './article-combo-large-images.component.scss';
var ArticleComboLargeImages = /** @class */ (function (_super) {
    tslib_1.__extends(ArticleComboLargeImages, _super);
    function ArticleComboLargeImages() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ArticleComboLargeImages.prototype.init = function () { };
    ArticleComboLargeImages.prototype.bindEvents = function () { };
    return ArticleComboLargeImages;
}(Base));
export { ArticleComboLargeImages };



//////////////////
// WEBPACK FOOTER
// ./components/article-combo-large-images/article-combo-large-images.component.ts
// module id = 98
// module chunks = 0